const translations = {
  page_title: 'Deals',

  deals_found_n: 'Deals found: {{n}}',
  search_placeholder: 'Search by make, model or VIN',
  new_deal: 'New deal',

  no_deals_search: 'There are no deals that match your search',
  no_deals: 'There are no deals yet',
  start_a_deal: 'Start a new deal to see it listed here',

  id: 'ID',
  image: 'Image',
  buyer: 'Buyer',
  seller: 'Seller',
  seller_2: 'Seller 2',
  days_column: 'Days',
  day: 'day',
  price: 'Price',
  vin: 'VIN',
  status: 'Status',
  required_fields: 'Required Fields',
  completed: 'Completed',
  missing: 'Missing',
  started_at: 'Started at',
  closed_at: 'Closed at',
  status_open: 'Open',
  status_done: 'Closed',
  status_cancelled: 'Cancelled',

  edit_deal: 'Edit deal',
  view_deal: 'View deal',
  days: 'days',

  description: 'Description',
  receipt_number: 'Receipt number',
  amount: 'Amount',
  added_at: 'Added',
  add_receipt: 'Add receipt',
  enter_amount: 'Enter amount',
  enter_description: 'Enter description',
  enter_number: 'Enter number',
  additional_message: 'Additional message',
  enter_additional_message: 'Enter additional message',
  bulk_actions: 'Bulk actions',
  delete_selected: 'Delete selected',
  download_selected: 'Download selected',

  deal_product_deleted_succesfully: 'Deal product deleted successfully',
  remove_deal_products: 'Remove deal products',
  remove_deal_product: 'Remove deal product',
  deal_products_remove_description: 'Are you sure you want to remove the selected deal products?',
  deal_product_remove_description: 'Are you sure you want to remove the selected deal product?',
  edit_deal_product: 'Edit product',
  add_deal_product: 'Add product',
  category: 'Category',
  name: 'Name',
  deal_products: 'Deal products',
  deal_products_description:
    'Add and manage optional products or services to include in the vehicle deal.',
  no_products_added: 'No products added yet',

  uploaded: 'Uploaded',
  not_uploaded: 'Not uploaded',
  add_item: 'Add item',
  item: 'Item',
  units: 'Units',
  unit_price: 'Unit price',
  notes: 'Notes',
  notes_placeholder: 'Type notes',
  date: 'Date',
  deal_closing_date: 'Deal closing date',
  deal_closing_date_placeholder: 'Select deal closing date',
  deal_closing_date_required: 'Deal closing date is required',

  close_deal: 'Close deal',
  close_deal_description: 'Are you sure you want to close this deal?',
  deal_updated_not_fully_paid: 'The deal was updated, but is not fully paid',
  deal_closed_success: 'Deal closed successfully',
  deal_closed_error: 'There are validation errors. Please fix them and try again.',
  deal_is_fully_paid: 'The deal is fully paid',
  validation_errors_message:
    'The deal contains missing required information, but it will be closed.',

  deal_not_fully_paid_message: 'The deal is not fully paid, but it will be closed.',
  cancel_deal: 'Cancel deal',
  cancel_deal_description: 'Are you sure you want to cancel this deal?',
  deal_cancelled_success: 'Deal cancelled successfully',
  deal_cancelled_error: 'There was an error.',

  all: 'All',
  open: 'Open',
  done: 'Closed',
  cancelled: 'Cancelled',

  last_month: 'Last month',
  previous_month: 'Previous month',
  prev_month: 'Prev. month',
  open_deals: 'Open deals',
  closed_deals: 'Closed deals',
  unpaid_deals: 'Unpaid deals',
  paid_deals: 'Paid deals',
  front_gross: 'Front gross',
  fgpm: 'FG Profit Margin',
  front_gross_profit_margin: 'Front gross Profit Margin',
  products: 'Products',

  this_month: 'This month',
  custom: 'Custom',
  sort_custom: 'Custom',

  payment_status: 'Payment status',
  select_payment_status: 'Select payment status',
  is_paid: 'Is paid',
  is_not_paid: 'Is not paid',
  select_required_fields_status: 'Select required fields status',
  missing_info: 'Missing info',
  period: 'Period',

  deal: 'Deal',
  type: 'Type',
  sale_price: 'Sale price',

  vehicle: 'Vehicle',
  stock_number: 'Stock #',

  mail: 'Email',
  phone: 'Phone',

  trade_in: 'Trade-in',
  trade_in_allowance: 'Allowance',
  trade_in_mileage: 'Mileage',
  '2nd_trade_in': '2nd Trade-in',

  finance: 'Finance',
  financing_amount: 'Amount',
  financing_apr: 'APR',

  purchase_price: 'Purchase price',
  costs: 'Costs',
  rebate: 'Rebate',
  trade_in_allowance_2: 'Allowance 2nd trade-in',
  conditioning: 'Conditioning',

  no_data: 'No data available',
  est_profit: 'Est. profit',
  allowance: 'Allowance',
  mileage: 'Mileage',
  apr: 'APR',
  email: 'Email',
  documents_loaded: 'Documents loaded successfully',
  download_documents: 'Download Documents',
  select_all_documents: 'Select All Documents',
  please_select_documents: 'Please select at least one document to download',
  documents_downloaded_success: 'Documents downloaded successfully',
  documents_download_error: 'Failed to download documents',
  no_documents_available: 'No documents available',
  document_name: 'Document Name',
  filename: 'Filename',

  payment: 'Payment',
  paid: 'Paid',
  unpaid: 'Unpaid',
  deal_status: 'Deal status',

  deal_load_error: 'This deal could not be loaded. You may not have permission to view it.',
  back_to_deals: 'Back to deals',
  deal_not_found: 'Deal not found',
};

export default translations;
